module.exports = __webpack_public_path__ + "static/media/tinyhappy.99925ce2.png";